import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { FiChevronUp } from 'react-icons/fi'

import { APSubItem } from './ap-sub-item'
import { ap_status } from '../../constants'
import { FONTS } from '../../../../constants'
import { findMin, findMax } from '../../function'
import { formatNumber } from '../../../../function/math.js'
import { revenueType } from '../../../project-information/tab-content/tab-revenue-planning/constants'

export const APItem = React.memo(({
  item,
  index,
  isExpand,
  handleClickRow,
  handleClickEdit,
}) => {
  const type = item.type ? revenueType[item.type].name : (item.vendor_id ? 'Other Service' : '-')
  const {
    accountant_paying_hardwares = [],
    accountant_paying_licenses = [],
    accountant_paying_vendors = [],
  } = item
  let partials = []

  if (item.hardware_id) {
    partials = accountant_paying_hardwares.find(h => h.hardware_id === item.hardware_id)
  } else if (item.license_id) {
    partials = accountant_paying_licenses.find(l => l.license_id === item.license_id)
  } else {
    partials = accountant_paying_vendors.find(v => v.vendor_id === item.vendor_id)
  }
  const updated_by = partials ? partials.update_by : ''
  const updated = partials ? partials.updated : ''
  const _status = ap_status.find(s => s.value === (partials ? partials.status : ''))
  partials = partials ? partials.partials : []

  const minDate = findMin(partials)
  const maxDate = findMax(partials)

  return (
    <Root>
      <Item onClick={ () => handleClickEdit(index) }>
        <Col onClick={ e => {
          handleClickRow(index)
          e.stopPropagation()
        } }
        >
          <ArrowWrapper active={ isExpand }>
            <FiChevronUp id='arrow' />
          </ArrowWrapper>
        </Col>
        <ProjCol name='product'>
          <NameText>
            <BoldText>{ type || '' }</BoldText>
            <SubtitleText>{ item._product_name || '-' }</SubtitleText>
            <div id='tooltip'>
              <TooltipText>{ type || '' }</TooltipText><br />
              <TooltipText>{ item._product_name || '-' }</TooltipText>
            </div>
          </NameText>
        </ProjCol>
        <ProjCol name='project'>
          <NameText>
            <BoldText>{ item.project_code } { item.project_name }</BoldText>
            <SubtitleText>{ item.description }</SubtitleText>
            <div id='tooltip'>
              <TooltipText>{ item.project_code } { item.project_name }</TooltipText><br />
              <TooltipText>{ item.description }</TooltipText>
            </div>
          </NameText>
        </ProjCol>
        <Col>
          <Text>{ item.client_name }</Text>
        </Col>
        <AmountCol>
          <BoldNumber>฿ { formatNumber(item.cost) }</BoldNumber>
        </AmountCol>
        <Col>
          <Number>
            { minDate ? moment(minDate).format('DD/MM/YYYY') : '-' }
          </Number>
        </Col>
        <Col />
        {/* <Number>{ item.credit_term ? `${item.credit_term} days` : '-' }</Number> */}
        {/* </Col> */}
        <Col>
          <Number>
            { maxDate ? moment(maxDate).format('DD/MM/YYYY') : '-'}
          </Number>
        </Col>
        <StatusCol>
          <StatusWrapper status={ _status }>
            <Dot status={ _status } />
            { _status ? _status.label : '-' }
          </StatusWrapper>
        </StatusCol>
        <TextWrapper>
          <Number>{ updated ? moment(updated).format('DD/MM/YYYY HH:mm') : '-' }</Number>
          <SubtitleText>{ updated_by }</SubtitleText>
        </TextWrapper>
      </Item>
      {isExpand && partials.map((parital, key) => (
        <APSubItem
          key={ key }
          data={ parital }
        />
      ))}
    </Root>
  )
})

const Root = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #F1F1F1;

  :nth-child(1) {
    border: none;
  }
`
const Item = styled.div`
  height: 50px;
  display: grid;
  grid-template-columns: 24px 100px minmax(auto, 250px) minmax(auto, 150px) 1fr 100px 100px 100px 100px 150px;
  grid-gap: 24px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
  background: #FFFFFF;
  padding: 0 24px;
  border-top: 1px solid #F1F1F1;
  cursor: pointer;

  @media (max-width: 1440px) {
    width: max-content;
    grid-template-columns: 24px 100px 200px 100px 100px 100px 100px 100px 100px 150px;
  }

  @media (max-width: 1024px) {
    width: max-content;
    grid-template-columns: 24px 100px 150px 100px 100px 100px 100px 100px 100px 150px;
  }

  :nth-child(1) {
    border: none;
  }

  #arrow {
    transform: ${p => (p.active ? 'rotate(90deg)' : 'rotate(0deg)')};
    transition: all 0.3s;
  }
`

const ProjCol = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  #tooltip {
    position: fixed;
    max-width: 300px;
    padding: 8px 12px;
    background: #FFFFFF;
    border: 1px solid #EAEAEA;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    color: #808080;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
    white-space: normal;
    z-index: 1;
  }

  #tooltip-${p => p.name}::after {
    position: absolute;
    bottom: 100%;
    left: 50%;
  }

  :hover {
    #tooltip-${p => p.name} {
      transition: opacity 0s ease;
      transition-delay: 1s;
      opacity: 1;
      visibility: visible;
    }
  }
`

const Col = styled(ProjCol)`
`

const AmountCol = styled(ProjCol)`
    justify-content: flex-end;
`

const StatusCol = styled.div`
  display: block;
  margin: auto 0;
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`

const TooltipText = styled(Text)`
  font-size: ${FONTS.SMALL_SIZE};
`

const NameText = styled(Text)`
  position: relative;
  display: block;
`

const BoldText = styled(Text)`
  font-family: ${FONTS.GOTHAM_BOLD};
  position: relative;
  display: block;
`

const SubtitleText = styled(Text)`
  color: #808080;
`

const Number = styled.span`
  font-family: ${FONTS.NOTOSANS};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
`

const BoldNumber = styled(Number)`
  text-align: right;
`

const StatusWrapper = styled.div`
  min-width: 90px;
  width: fit-content;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => (p.status ? p.status.bg : '')};
  color: ${p => (p.status ? p.status.color : '')};
  border-radius: 4px;
  padding: 0 10px;
`

const Dot = styled.div`
  width: 6px;
  height: 6px;
  background: ${p => (p.status ? p.status.color : '')};
  border-radius: 50%;
  margin-right: 6px;
`

const ArrowWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => (p.active ? '#2D9CDB' : 'rgba(45, 156, 219, 0.08)')};
  border-radius: 4px;
  cursor: pointer;

  #arrow {
    font-size: 16px;
    transform: ${p => (p.active ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: all 0.3s;
    color: ${p => (p.active ? '#FFF' : '#2D9CDB')};
  }
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/data-table/ap-paying/ap-item.js